<div class="payment-history-container">
  <h3>Ödəniş tarixçəsi</h3>
  <div class="table-wrapper" *ngIf="payments.length > 0; else emptyState">
    <table class="table">
      <thead>
        <tr>
          <th>Tarix/Saat</th>
          <th>Əməliyyat tipi</th>
          <th>Məbləğ</th>
          <th>Status</th>
          <th>Tranzaksiya ID</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let payment of payments">
          <td>{{payment.date}}</td>
          <td>{{payment.type}}</td>
          <td>{{payment.amount}} ₼</td>
          <td><span class="badge" [ngClass]="payment.status.toLowerCase()">{{payment.status}}</span></td>
          <td>{{payment.id}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <p>Məlumat tapılmadı</p>
    </div>
  </ng-template>
</div>
